angular.module 'zc.projects'

.directive 'projectExcludeIps', ($translate, installationApi) ->
  directive =
    restrict: "E"
    scope: {
      excludeIps: "="
    }
    template: """
<section>
  <div class="row">
    <div class="col-md-6">
      <h5>#{$translate.instant('projects.directives.projects.projectExcludeIps.currentIp')}</h5>
      <table class="table table-bordered table-hover">
        <tbody>
          <tr ng-repeat="excludeIp in excludeIps">
            <td><h2 class="text-danger">{{excludeIp}}</h2></td>
            <td><button type="button" class="close" aria-hidden="true" ng-click="remove(excludeIp)">×</button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <form novalidate name="ipForm">
    <div class="row">
      <div class="col-md-8">
        <h5 class="text-left">#{$translate.instant('projects.directives.projects.projectExcludeIps.addExcludeIp')}</h5>
        <div class="row">
          <div class="col-md-8">
            <input type="text" class="form-control" name="newIp"
                placeholder="xxx.xxx.xxx.xxx"
                ng-model="inputs.newIp"
                ng-pattern="ipRegexp"
                required>
          </div>
          <div class="col-md-4">
            <button type="submit" class="btn btn-block btn-default"
                    ng-click="addIp()"
                    ng-disabled="(!ipForm) || (alreadyExists())"
            >#{$translate.instant('projects.directives.projects.projectExcludeIps.register')}</button>
          </div>
        </div>
      </div>
    </div>
  <div ng-show="isoverlap()" class="label label-danger">#{$translate.instant('projects.directives.projects.projectExcludeIps.noDuplicateIpAllowed')}</div>
  </form>
</section>
    """

    link: (scope, element, attrs) ->

    controller: ($scope) ->
      $scope.ipRegexp = /\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/
      $scope.inputs =
        newIp: ""

      # get current ip
      installationApi.getIpAddresss()
      .then (data)->
        angular.forEach data, (v, i)->
          $scope.ips.push v

      $scope.alreadyExists = () ->
        $scope.excludeIps.indexOf($scope.inputs.newIp) >= 0

      $scope.remove = (excludeIp) ->
        installationApi.deleteIpAdress(excludeIp)
        .then (res) ->
          $scope.excludeIps.splice($scope.excludeIps.indexOf(excludeIp), 1)

      $scope.addIp = () ->
        installationApi.setIpAddress(excludeIp)
        .then (res) ->
          $scope.excludeIps.push $scope.inputs.newIp

  directive



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects/directives/projects/project_exclude_ips.js.coffee